<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="col-12">
                <h1 class="title-tab-content">اعتبار من</h1> <!--کیف پول-->
            </div>
            <div class="content-section default">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="profile-recent-fav-row box-credit">
                            <div class="credit-title">
                                <label class="credit-mony-title">
                                    موجودی کیف پول شما <!--موجودی کیف پول شما-->
                                </label>
                            </div>
                            <div class="mony-credit">
                                <span class="digit-credit"> {{ balance | formatNumber}} تومان<span class="toman-credit"></span></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="credit-plus"><hr /></div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">پرداخت از طریق درگاه بانکی</a>
                                <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="true">پرداخت به صورت کارت به کارت</a>
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                            <directbank-payment></directbank-payment>
                            <creditcart-payment></creditcart-payment> 

                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
    </div>

</template>

<script>
    import { httpPromise } from "../../../module/httpUtility"; 
    import creditCartPayment from "./creditCartPayment.vue";
    import directBankPayment from "./directBankPayment.vue";
    export default {
        data() {
            return {
                balance: 0, isShowSppiner: false
            }
        },
        components: { 
            'creditcart-payment': creditCartPayment,
            'directbank-payment': directBankPayment
        },
        beforeMount: function () {
            this.isShowSppiner = true;
            createPageTitle('اعتبار من');
            httpPromise(this, '/v1/Identity/CustomerFininces/GetBalance', 'get', '',
                response => {
                    toastr.remove();
                    this.balance = response.data.Value.Balance;
                    this.isShowSppiner = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isShowSppiner = false;
                });
        },
    }
</script>>

<style scoped>
    .nav-tabs .nav-link.active {
        border: 1px solid #89d5ac !important;
    }

    .nav-tabs .nav-link {
        margin-left: 5px;
        margin-right: 5px;
    }

        .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
        }

    @media only screen and (min-width: 0px) and (max-width:768px) {
        .nav-tabs {
            display: inline-block;
            width: 100%;
            padding-left: 0px;
            padding-right: 0px;
            text-align: center;
        }
    }

    .aaaa {
        padding: 11px 10px 11px 11px;
    }

    .dk-btn-info {
        overflow: hidden;
    }

    .form-account-title {
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .account-box {
        margin: 25px auto;
        border-radius: 5px;
    }

    .credit-plus-p {
        text-align: center;
    }

    .credit-plus-p {
        margin-bottom: 15px;
    }

        .credit-plus-p span {
            font-size: 16px;
            font-weight: bold;
        }

    .div-p-credit p {
        text-align: justify;
        font-size: 15px !important;
        line-height: 1.8;
        padding: 8px;
    }

    .credit-mony-title {
        font-size: 18px;
        font-weight: bold;
    }

    .box-credit {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 8px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .credit-title {
        margin-left: 25px;
    }

    .toman-credit {
        font-size: 14px;
        color: #333;
    }

    .digit-credit {
        font-size: 16px;
        color: #000;
        font-weight: bold;
    }

    .radio label::before, .radio label::after {
        content: " ";
        right: -35px !important;
        top: 3px;
    }

    .product-variants .radio input[type="radio"]:checked + label::after {
        top: 6px;
    }

    .radio {
        float: right !important;
        padding-right: 40px !important;
    }

    .parent-btn, .parent-btn[data-v-71e4f434] {
        overflow: unset !important;
    }
</style>